import { ActivateFormValue, ExtendedOnboardingLinkAddon } from "src/app/features/sales/models/activate-link.model";
import { TIME_UNITS } from "../models/activation-link.model";
import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function calculateExpiryDate(formValue: ActivateFormValue): Date {
  let expiryDate = new Date();
  if (formValue.expires.unit === TIME_UNITS.hours) {
    expiryDate.setHours(expiryDate.getHours() + formValue.expires.value);
  } else {
    expiryDate.setDate(expiryDate.getDate() + formValue.expires.value);
  }
  return expiryDate;
}


export function atLeastOneMoreThanZero(subStr: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const isValid = control.value
      .filter((v: ExtendedOnboardingLinkAddon) => v.id.includes(subStr))
      .some((v: ExtendedOnboardingLinkAddon) => v.quantity > 0);
    if(!isValid) return {
      missing_required_addon: subStr
    }
    return null;
  }
}